import { ReactElement, ReactNode } from 'react';
import { debug } from 'zf-web-infra';
import { ColumnProps } from 'antd/es/table';
import { CustomizeProps } from '../types';

export function Customize(props: CustomizeProps): ReactElement | null {
  debug.common('CustomizeProps', props);
  return null;
}

Customize.displayName = 'Customize';

export function getCustomizeProps<T>(child: ReactElement<ColumnProps<T>>): ColumnProps<T> {
  const { render } = child.props as CustomizeProps;
  return {
    ...child.props, render: (value): ReactNode => render(value)
  };
}
